/** ***********************************************************************
 *
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 ************************************************************************* */

import { observer } from 'mobx-react';
import React from 'react';
import BannerItem from '../../components/banner/item';
import LoadingTransitionHOC from '../../components/LoadingTransitionHOC';
import './layout.scss';


export default LoadingTransitionHOC(observer(({
    bannerItems, bannerItemLayouts, bannerAnalyticsCallback,
    bannerSectionId, bannerPlatform, appConfig, appsSkeletonModel, allAppsModel, childRef,
}) => {
    if (bannerItems.length) {
        bannerItems[0].setAnalytics({ widthType: '2/3', bannerAnalyticsCallback });
    }

    if (bannerItems.length > 1) {
        bannerItems[1].setAnalytics({ widthType: '1/3', bannerAnalyticsCallback });
    }

    return (
        <div ref={childRef} className="two-third-one-third-banner-layout">
            <BannerItem
                bannerItem={bannerItems[0]}
                bannerItemLayouts={bannerItemLayouts}
                bannerSectionId={bannerSectionId}
                bannerPlatform={bannerPlatform}
                appConfig={appConfig}
                appsSkeletonModel={appsSkeletonModel}
                allAppsModel={allAppsModel}
            />
            <BannerItem
                bannerItem={bannerItems[1]}
                bannerItemLayouts={bannerItemLayouts}
                bannerSectionId={bannerSectionId}
                bannerPlatform={bannerPlatform}
                appConfig={appConfig}
                appsSkeletonModel={appsSkeletonModel}
                allAppsModel={allAppsModel}
            />
        </div>
    );
}));
